<template>
  <div class="gardenMatchingList">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="back">{{$t('lang.btn_wj_returnNews')}}</el-button>
      </div>
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="matchTypeSearch" placeholder="请选择配套类别">
            <el-option key label="请选择配套类别" value=''></el-option>
            <el-option v-for="item in matchType" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="isInGardenSearch"  placeholder="请选择是否在园区内">
            <el-option key label="请选择是否在园区内" value=''></el-option>
            <el-option v-for="item in yesorno" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" @click="getData()">{{$t('lang.btn_search')}}</el-button>
        <el-button type="primary" style="float:right;margin-bottom:10px;" @click="add">新增</el-button>
      </el-form>
      
      <el-table :data="tableData"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        class="wid100" :row-class-name="tableRowClassName">
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column prop="matchName" label="配套名称"></el-table-column>
        <el-table-column prop="matchType" label="配套类别">
          <template slot-scope="scope">
            <span v-if="scope.row.matchType == 1">地铁</span>
            <span v-if="scope.row.matchType == 2">公交</span>
            <span v-if="scope.row.matchType == 3">幼儿园</span>
            <span v-if="scope.row.matchType == 4">小学</span>
            <span v-if="scope.row.matchType == 5">超市</span>
            <span v-if="scope.row.matchType == 6">丰巢</span>
          </template>
        </el-table-column>
        <el-table-column prop="isInGarden" label="是否园区内">
          <template slot-scope="scope">
            <span v-if="scope.row.isInGarden == 1">是</span>
            <span v-if="scope.row.isInGarden == 2">否</span>
          </template>
        </el-table-column>
        <el-table-column prop="isRangeOne" label="是否一公里范围内">
          <template slot-scope="scope">
            <span v-if="scope.row.isRangeOne == 1">是</span>
            <span v-if="scope.row.isRangeOne == 2">否</span>
          </template>
        </el-table-column>
        <el-table-column prop="isRangeThree" label="是否三公里范围内">
          <template slot-scope="scope">
            <span v-if="scope.row.isRangeThree == 1">是</span>
            <span v-if="scope.row.isRangeThree == 2">否</span>
          </template>
        </el-table-column>
        <el-table-column prop="nearbyDoor" label="较近门岗"></el-table-column>
        <el-table-column prop="operation" :label="$t('lang.lab_operation')"
          :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="deleteOne(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <!-- 新增周边配套信息弹窗 -->
    <el-dialog title="小区周边配套信息" :visible.sync="dialogVisible" :close-on-click-modal="false" center top="130px"
      width="900px">
      <el-form :model="ruleForm" name="frm" :rules="rules" ref="ruleForm" class="wid100"
        :label-width="require('@/config/enum').c_ws10" :label-suffix="require('@/config/enum').c_colon">

        <el-form-item tem label="配套名称" prop="matchName">
          <el-input v-model="ruleForm.matchName" placeholder="请输入" class="item-input" style="width:90%" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="配套类别" prop="matchType">
          <el-select v-model="ruleForm.matchType" placeholder="请选择" style="width:90%">
            <el-option v-for="item in matchType" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item tem label="是否园区内" prop="isInGarden">
          <el-select v-model="ruleForm.isInGarden" placeholder="请选择" style="width:90%">
            <el-option v-for="item in yesorno" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item tem label="是否一公里范围内" prop="isRangeOne">
          <el-select v-model="ruleForm.isRangeOne" placeholder="请选择" style="width:90%">
            <el-option v-for="item in yesorno" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item tem label="是否三公里范围内" prop="isRangeThree">
          <el-select v-model="ruleForm.isRangeThree" placeholder="请选择" style="width:90%">
            <el-option v-for="item in yesorno" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item tem label="较近门岗" prop="nearbyDoor">
          <el-input v-model="ruleForm.nearbyDoor" placeholder="请输入" class="item-input" style="width:90%" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="备注" prop="remark">
          <el-input v-model="ruleForm.remark" placeholder="请输入" class="item-input" type="textarea"
            :autosize="{ minRows: 4}" style="width:90%" maxlength="500">
          </el-input>
        </el-form-item>
        <div class="jump-btn" style="text-align:center">
          <el-button class="detailbtn" type="primary" @click="save('ruleForm')" :disabled="isDisabled">
            保存
          </el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  /**
   *@ClassName:gardenMatchingList
   *@Description:小区周边配套信息
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-02-19
   */
  import {
    mapGetters
  } from 'vuex'
  export default {
    data() {
      return {
        matchType: this.$i18n.t('lang.matchType'),
        yesorno: this.$i18n.t('lang.yesorno'),
        saveData: '',
        isDisabled: true,
        id: '', // 配套id
        tableData: [], // 周边配套list
        pageNo: 1, // 页数
        pageSize: 10, // 每页显示数量
        pageCount: 0, // 总页数
        dialogVisible: false, // 新增弹窗状态
        rules: {
          matchName: [{
            required: true,
            message: '请输入配套名称',
            trigger: 'blur'
          }],
          matchType: [{
            required: true,
            message: '请选择配套类别',
            trigger: 'change'
          }],
          isInGarden: [{
            required: true,
            message: '请选择是否在园区内',
            trigger: 'change'
          }],
          isRangeOne: [{
            required: true,
            message: '请选择是否一公里范围内',
            trigger: 'change'
          }],
          isRangeThree: [{
            required: true,
            message: '请选择是否三公里范围内',
            trigger: 'change'
          }],
          nearbyDoor: [{
            required: true,
            message: '请输入较近门岗',
            trigger: 'blur'
          }],
        },
        matchTypeSearch: '', // 配套类别(搜索)
        isInGardenSearch: '', // 是否园区内(搜索)
        ruleForm: {
          matchName: '', // 配套名称
          matchType: '', // 配套类别
          isInGarden: '', // 是否园区内
          isRangeOne: '', // 是否一公里范围内
          isRangeThree: '', // 是否三公里范围内
          nearbyDoor: '', // 较近门岗
          remark: '', // 备注
        },
      }
    },
    watch: {
      ruleForm: {
        handler(newVal, oldVal) {
          // ruleForm数据变化时 会调用此方法
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData) {
            // 没变
            this.isDisabled = true
          } else {
            // 变了
            this.isDisabled = false
          }
        },
        deep: true,
        immediate: true
      }
    },
    computed: {
      ...mapGetters(['gardenId'])
    },
    created() {
      this.getData()
    },
    methods: {
      // 返回上一级
      back() {
        this.$router.push({
          name: 'projectPortrait'
        })
      },
      // 获取周边配套列表
      getData() {
        let loading = this.$loading()
        this.$get(`/gardenDrawGardenMatch?gardenId=${this.gardenId}&matchType=${this.matchTypeSearch}&isInGarden=${this.isInGardenSearch}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 新增周边配套信息
      add() {
        this.id = ''
        this.ruleForm.matchName = ''
        this.ruleForm.matchType = ''
        this.ruleForm.isInGarden = ''
        this.ruleForm.isRangeOne = ''
        this.ruleForm.isRangeThree = ''
        this.ruleForm.nearbyDoor = ''
        this.ruleForm.remark = ''
        this.dialogVisible = true
      },
      // 编辑周边配套信息
      edit(rowData) {
        this.id = rowData.id
        this.ruleForm.matchName = rowData.matchName
        this.ruleForm.matchType = rowData.matchType
        this.ruleForm.isInGarden = rowData.isInGarden
        this.ruleForm.isRangeOne = rowData.isRangeOne
        this.ruleForm.isRangeThree = rowData.isRangeThree
        this.ruleForm.nearbyDoor = rowData.nearbyDoor
        this.ruleForm.remark = rowData.remark
        this.saveData = JSON.stringify(this.ruleForm)
        this.dialogVisible = true
      },
      // 删除周边配套信息
      deleteOne(id) {
        let loading = this.$loading()
        this.$confirm(this.$i18n.t('lang.lab_isdelete'), this.$i18n.t('lang.lab_prompt'), {
            confirmButtonText: this.$i18n.t('lang.btn_confirm'),
            cancelButtonText: this.$i18n.t('lang.btn_cancel'),
            type: 'warning'
          }).then(() => {
            this.$delete(`/gardenDrawGardenMatch/` + id).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.getData()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      },
      // 保存
      save(formName) {
        let params = this.ruleForm
        params.gardenId = this.gardenId
        console.log('params', params)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let loading = this.$loading()
            if (!this.id) {
              // 新增
              this.$post('/gardenDrawGardenMatch', params).then(
                res => {
                  loading.close()
                  console.log(res)
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.getData()
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            } else {
              // 编辑
              this.$patch(`/gardenDrawGardenMatch/${this.id}`, params).then(
                res => {
                  loading.close()
                  console.log(res)
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.getData()
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            }
          } else {
            return false
          }
        })

        this.dialogVisible = false
        this.ruleForm.matchName = ''
        this.ruleForm.matchType = ''
        this.ruleForm.isInGarden = ''
        this.ruleForm.isRangeOne = ''
        this.ruleForm.isRangeThree = ''
        this.ruleForm.nearbyDoor = ''
        this.ruleForm.remark = ''
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.getData()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.getData()
      },
      // 表格斑马
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
    },
  }
</script>

<style lang="scss">
  .gardenMatchingList {}
</style>